
import { Component, useEffect, useState } from 'react';
import { DataScroller } from 'primereact/datascroller';
import { getCouponsDate, getCouponsTypeDescription, getStatusCouponTime } from '../../../utilities/coupon.utilities';
import JsBarcode from 'jsbarcode';
import { useLocation } from 'react-router-dom';
import { getAllCustomerInfo } from '../../../service/allCustomerInfo.service';
import React from 'react';
import LoadingSpinner from '../../loading-spinner/loading-spinner';
import { goTo } from '../../../utilities/common.utilities';
import { useConnectivity } from '../../../context/connectivityContext';
import './allCoupons.component.css';

interface Coupons {
    appPicture: string;
    appTemplate: string;
    couponCode: string;
    couponType: string;
    description: string;
    dynamicRedemptionValue: number;
    endDate: string;
    id: number;
    isBonusCampaign: boolean;
    isDynamicRedemption: boolean;
    isInfoCoupon: boolean;
    issuingDate: string;
    issuingFrom: string;
    issuingStoreId: number;
    issuingTo: string;
    issuingType: string;
    name: string;
    promotedCategories: any[];
    promotedCategoriesDetail: any[];
    promotedProducts: string[];
    promotedProductsDetail: { code: string; name: string }[];
    promotedSuppliers: any[];
    promotedSuppliersDetail: any[];
    rating: number;
    redemptionFrom: string;
    redemptionTo: string;
    redemptionWithinDate: string;
    startDate: string;
    value: number;
    //inventoryStatus: string;
    barcode: string;
    showBarcode: boolean;
    showDescription: boolean;
}
export default function AllCouponsComponent() {
const location = useLocation();

// Se non sono presenti dati in location.state, reindirizzo in home al posto
// di far andare in errore il componente
if(!location.state) {
    goTo('/home');
}

const { cardData } = location.state;
const [coupons, setCoupons] = useState<Coupons[]>([]);

// Variabile utilizzata per sapere se ci sono errori nella ricezione dei coupon come l' assenza di connessione.
// Utilizzata per distinguere sul template, se la mancanza di coupon è dovuta ad errore oppure effettivamente non c'è ne sono.
const [errorGetCoupon, setErrorGetCoupon] = useState<boolean>(false);
const { isOnline } = useConnectivity();

    const textToBase64Barcode = (text: string) => {
        var canvas = document.createElement("canvas");
        JsBarcode(canvas, text, {
            format: "CODE128",
            width: 3,
            background: "white",
            displayValue: false,
        });
        return canvas.toDataURL("image/png");
    };

    const getCoupons = () => {
        
            getAllCustomerInfo(cardData.groupCode, cardData.storeCode, cardData.selectedCard).then(allCustomerInfo => {
                let result: Coupons[] = []; 
                setErrorGetCoupon(false);
                    if(!allCustomerInfo) {
                        result = [];
                        setErrorGetCoupon(true);
                    }
                    else if(allCustomerInfo?.loyalties?.coupons?.length > 0){
                        
                        allCustomerInfo.loyalties.coupons.map((x: Coupons) => {
                            result.push({
                            appPicture: x.appPicture ? x.appPicture.replace('/storage','') : '',
                            appTemplate: x.appTemplate,
                            couponCode: x.couponCode,
                            couponType: x.couponType,
                            description: x.description,
                            dynamicRedemptionValue: x.dynamicRedemptionValue,
                            endDate: x.endDate,
                            id: x.id,
                            isBonusCampaign: x.isBonusCampaign,
                            isDynamicRedemption: x.isDynamicRedemption,
                            isInfoCoupon: x.isInfoCoupon,
                            issuingDate: x.issuingDate,
                            issuingFrom: x.issuingFrom,
                            issuingStoreId: x.issuingStoreId,
                            issuingTo: x.issuingTo,
                            issuingType: x.issuingType,
                            name: x.name,
                            promotedCategories: x.promotedCategories,
                            promotedCategoriesDetail: x.promotedCategoriesDetail,
                            promotedProducts: x.promotedProducts,
                            promotedProductsDetail: x.promotedProductsDetail,
                            promotedSuppliers: x.promotedSuppliers,
                            promotedSuppliersDetail: x.promotedSuppliersDetail,
                            rating: x.rating,
                            redemptionFrom: x.redemptionFrom,
                            redemptionTo: x.redemptionTo,
                            redemptionWithinDate: x.redemptionWithinDate,
                            startDate: x.startDate,
                            value: x.value,
                            //inventoryStatus: getStatusCouponTime(x),
                            barcode: textToBase64Barcode(x.couponCode),
                            showBarcode: false,
                            showDescription: false
                        });
                    });
                } else {
                    result = [];
                }

                if(result.length > 0){
                    setCoupons(result);
                  } else {
                    setCoupons([]);
                }

            })
            
    };

    useEffect(() => {
        getCoupons();      
      }, [isOnline]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore


    const handleToggleClick = (id: number) => {
        const temp_coupons = coupons.map((x) => {
            if (x.id === id) {
                return {
                    appPicture: x.appPicture,
                    appTemplate: x.appTemplate,
                    couponCode: x.couponCode,
                    couponType: x.couponType,
                    description: x.description,
                    dynamicRedemptionValue: x.dynamicRedemptionValue,
                    endDate: x.endDate,
                    id: x.id,
                    isBonusCampaign: x.isBonusCampaign,
                    isDynamicRedemption: x.isDynamicRedemption,
                    isInfoCoupon: x.isInfoCoupon,
                    issuingDate: x.issuingDate,
                    issuingFrom: x.issuingFrom,
                    issuingStoreId: x.issuingStoreId,
                    issuingTo: x.issuingTo,
                    issuingType: x.issuingType,
                    name: x.name,
                    promotedCategories: x.promotedCategories,
                    promotedCategoriesDetail: x.promotedCategoriesDetail,
                    promotedProducts: x.promotedProducts,
                    promotedProductsDetail: x.promotedProductsDetail,
                    promotedSuppliers: x.promotedSuppliers,
                    promotedSuppliersDetail: x.promotedSuppliersDetail,
                    rating: x.rating,
                    redemptionFrom: x.redemptionFrom,
                    redemptionTo: x.redemptionTo,
                    redemptionWithinDate: x.redemptionWithinDate,
                    startDate: x.startDate,
                    value: x.value,
                    //inventoryStatus: x.inventoryStatus,
                    barcode: x.barcode,
                    showBarcode: !x.showBarcode,
                    showDescription: x.showDescription
                };
            } else {
                return x;
            }
        });
        setCoupons(temp_coupons);
    }

    const handleShowDescription = (id: number) => {
        const temp_coupons = coupons.map((x) => {
            if (x.id === id) {
                return {
                    appPicture: x.appPicture,
                    appTemplate: x.appTemplate,
                    couponCode: x.couponCode,
                    couponType: x.couponType,
                    description: x.description,
                    dynamicRedemptionValue: x.dynamicRedemptionValue,
                    endDate: x.endDate,
                    id: x.id,
                    isBonusCampaign: x.isBonusCampaign,
                    isDynamicRedemption: x.isDynamicRedemption,
                    isInfoCoupon: x.isInfoCoupon,
                    issuingDate: x.issuingDate,
                    issuingFrom: x.issuingFrom,
                    issuingStoreId: x.issuingStoreId,
                    issuingTo: x.issuingTo,
                    issuingType: x.issuingType,
                    name: x.name,
                    promotedCategories: x.promotedCategories,
                    promotedCategoriesDetail: x.promotedCategoriesDetail,
                    promotedProducts: x.promotedProducts,
                    promotedProductsDetail: x.promotedProductsDetail,
                    promotedSuppliers: x.promotedSuppliers,
                    promotedSuppliersDetail: x.promotedSuppliersDetail,
                    rating: x.rating,
                    redemptionFrom: x.redemptionFrom,
                    redemptionTo: x.redemptionTo,
                    redemptionWithinDate: x.redemptionWithinDate,
                    startDate: x.startDate,
                    value: x.value,
                    //inventoryStatus: x.inventoryStatus,
                    barcode: x.barcode,
                    showBarcode: x.showBarcode,
                    showDescription: !x.showDescription
                };
            } else {
                return x;
            }
        });
        setCoupons(temp_coupons);
    }

    const itemTemplate = (data: Coupons) => {
        return (
            <div
                className="col-12 bg-white mt-2 p-0 mb-4 custom-card"
                // style={{ border: "1px solid #a8a8a7", borderRadius: "8px" }}
            >
                <div className="flex flex-column">
                    {
                        data.appPicture ?
                            <img
                                src={process.env.REACT_APP_STORAGE_URL
                                 + data.appPicture}
                                style={{ borderRadius: "8px 8px 0 0" , borderBottom: '1px solid #edecec'}}
                                alt={data.name}
                            />
                            : <div></div>
                    }

                    <div className="p-2 pt-0">
                        <div className="flex overflow-hidden">
                            <div className="flex-grow-1 flex align-items-start justify-content-start">
                                <h2 className="mt-2 mb-0">{data.name}</h2>
                            </div>
                        </div>

                        {
                          data.appTemplate?.length > 0 // Se è presente il template lo visualizzo
                          ?
                          <div dangerouslySetInnerHTML={{ __html: data.appTemplate }}></div>
                          :
                          (
                            data.description?.length > 0  // altrimenti se c'è, visualizzo la descrizione
                            ?
                            <div className="block mt-2">{data.description}</div>
                            :
                            <></>  // altrimenti nulla (e verrà visualizzata solo la descrizione generata lato client)
                          )
                        }

                            { (getCouponsTypeDescription(data) && (data.appTemplate || data.description)) ?
                            <div>
                                <div
                                    className="block"
                                    style={{ fontSize: "14px" }}
                                >
                                    <div className="flex overflow-hidden mt-2">
                                        <div
                                            className="flex-none flex align-items-center justify-content-end p-1"
                                            onClick={() => handleShowDescription(data.id)} style={{ cursor:'pointer'}}
                                        >
                                            <div
                                                className="flex p-1 all-coupon-description-show "
                                            >
                                                <div className="font-bold px-2">
                                                    {!data.showDescription
                                                        ? "Scopri di più"
                                                        : "Mostra meno"}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {data.showDescription ? (
                                    <div className="flex justify-content-center mt-0 px-2">
                                        <div className="flex flex-wrap align-items-center justify-content-center bg-white" style={{ fontStyle: 'italic' }}
                                            dangerouslySetInnerHTML={{ __html: getCouponsTypeDescription(data) }}>
                                        </div>
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                            </div>
                            : 
                            <div className="block mt-2" dangerouslySetInnerHTML={{ __html: getCouponsTypeDescription(data) }}>
                            </div>
                                } 
                        

                        {!data.isInfoCoupon ? (
                            <div>
                                <div className="flex-grow-1 flex align-items-start justify-content-start p-1">
                                    <div style={{ color: getStatusCouponTime(data) }}>
                                        {getCouponsDate(data)}
                                    </div>
                                    <div
                                        className="font-bold ml-1"
                                        style={{ fontSize: "8px" }}
                                    ></div>
                                </div>
                                <div className="flex overflow-hidden">
                                    <div className="flex-grow-1 flex align-items-center justify-content-start">
                                        <div
                                            className="flex-none flex align-items-center justify-content-end p-1"
                                            onClick={() => handleToggleClick(data.id)} style={{cursor:'pointer'}}
                                        >
                                            <div
                                                className="flex p-1 all-coupon-status-show "
                                            >
                                                <div className="font-bold px-2">
                                                    {!data.showBarcode
                                                        ? "Visualizza Coupon"
                                                        : "Nascondi Coupon"}
                                                </div>
                                                <i
                                                    className="pi pi-barcode ml-1 mr-2"
                                                    style={{ fontSize: "1rem" }}
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="flex-none flex align-items-center justify-content-center">
                                        <div className="flex flex-column">
                                            <div>
                                                <img
                                                    src="EXPERIENCE_APP_ICONE_coupons.png"
                                                    alt="coupon"
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div> */}
                                </div>

                            </div>
                        ) : (
                            <div></div>
                        )}
                        {data.showBarcode ? (
                            <div className="flex justify-content-center mt-2">
                                <div className="flex flex-wrap align-items-center justify-content-center bg-white barcodeCardContainer">
                                    <img
                                        className="barcodeCard"
                                        src={data.barcode}
                                        alt="Barcode"
                                    />
                                    <div className="flex justify-content-center">
                                        <div className="flex align-items-center justify-content-center text-2xl barCodeNumber">
                                            {" "}
                                            {data.couponCode}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    
        return (
                
                <div>
                    <div className="flex justify-content-center">
                        <h2 className="mb-0 mt-2">Coupon</h2>
                    </div>
                    <DataScroller
                        value={coupons}
                        itemTemplate={itemTemplate}
                        rows={100}
                        buffer={0.4}
                        header=""
                        emptyMessage={
                            // <div className='text-center mt-5 text-lg'>Nessun Coupon trovato</div> 
                            <div className="text-center text-lg mt-5">
                                {
                                    errorGetCoupon
                                    ?
                                    <div className="flex flex-column">

                                        {
                                            isOnline
                                            ?
                                            <></>
                                            :
                                            <div className='mb-3'>
                                            <img src="./offline_globe.svg" alt="" className="img-offline-globe-empty-result"></img>
                                            </div>
                        
                                        }

                                        <div>Impossibile caricare i Coupon.</div>
                                        {
                                            navigator.onLine
                                            ?
                                            <></>
                                            :
                                            <div>Verifica la connessione internet.</div>
                                        }
                                    </div>
                                    :
                                    <div className='nothing-find' >Nessun Coupon trovato</div>
                                }
                            </div>
                        }
                    />
                </div>
        );
    
}